import React from "react";
import styled from "styled-components";
import resume from "../images/pexels-ann-nekr-5797899.jpg";
import PrimaryButton from "./PrimaryButton";
import { Link } from "react-router-dom";

function ImageSection() {
  return (
    <ImageSectionStyled>
      <div className="left-content">
        <img src={resume} alt="" />
      </div>
      <div className="right-content">
        <h4>
          I am <span>Preeti Cyril Mammen</span>
        </h4>
        <p className="paragraph">
          Being a Test Automation Framework developer, I developed this newfound
          interest in learning tools and technologies and to do more coding.
          Colors and Creativity inspired me and thats how I landed onto the
          course from Zero To Mastery for Complete Web Developer. I am
          passionate in what I do and like to learn new things and do some
          hands-on where technology is related. If I am not
          learning/testing/coding, I like to READ articles and books (anything
          that interests me).
        </p>
        <div className="about-info">
          <div className="info-title">
            <p>Full Name</p>
            <p>Languages </p>
            <p>Location</p>
            <p>Interests</p>
          </div>
          <div className="info">
            <p>: Preeti Cyril Mammen</p>
            <p>: English, Hindi, Malayalam </p>
            <p>: Melbourne, Australia</p>
            <p>: Reading, Learning</p>
          </div>
        </div>
        <Link to="/Preeti_Cyril_Mammen_Resume.pdf" target="_blank">
          <PrimaryButton title={"Download CV"} />
        </Link>
      </div>
    </ImageSectionStyled>
  );
}

const ImageSectionStyled = styled.div`
  margin-top: 5rem;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .left-content {
      margin-bottom: 2rem;
    }
  }
  .left-content {
    width: 100%;
    img {
      width: 95%;
      object-fit: cover;
    }
  }
  .right-content {
    width: 100%;
    h4 {
      font-size: 2rem;
      color: var(--white-color);
      span {
        font-size: 2rem;
      }
    }
    .paragraph {
      padding: 1rem 0;
    }
    .about-info {
      display: flex;
      padding-bottom: 1.4rem;
      .info-title {
        padding-right: 3rem;
        p {
          font-weight: 600;
        }
      }
      .info-title,
      .info {
        p {
          padding: 0.3rem 0;
        }
      }
    }
  }
`;
export default ImageSection;
